var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14706 3.08838H19.5595C20.6967 3.08838 21.6184 4.01019 21.6184 5.1473V19.5598C21.6184 20.6969 20.6967 21.6187 19.5595 21.6187H5.14706C4.00995 21.6187 3.08813 20.6969 3.08813 19.5598V5.1473C3.08813 4.01019 4.00995 3.08838 5.14706 3.08838ZM8.23544 18.5303C8.51972 18.5303 8.75017 18.2998 8.75017 18.0156V10.8093C8.75017 10.5251 8.51972 10.2946 8.23544 10.2946H6.69125C6.40697 10.2946 6.17652 10.5251 6.17652 10.8093V18.0156C6.17652 18.2998 6.40697 18.5303 6.69125 18.5303H8.23544ZM7.46335 9.26515C6.61051 9.26515 5.91915 8.57379 5.91915 7.72095C5.91915 6.86812 6.61051 6.17676 7.46335 6.17676C8.31618 6.17676 9.00754 6.86812 9.00754 7.72095C9.00754 8.57379 8.31618 9.26515 7.46335 9.26515ZM18.0153 18.5303C18.2996 18.5303 18.5301 18.2998 18.5301 18.0156V13.28C18.5635 11.644 17.354 10.2478 15.7299 10.0475C14.5944 9.94382 13.4942 10.4741 12.868 11.427V10.8093C12.868 10.5251 12.6375 10.2946 12.3533 10.2946H10.8091C10.5249 10.2946 10.2944 10.5251 10.2944 10.8093V18.0156C10.2944 18.2998 10.5249 18.5303 10.8091 18.5303H12.3533C12.6375 18.5303 12.868 18.2998 12.868 18.0156V14.1551C12.868 13.3023 13.5594 12.6109 14.4122 12.6109C15.265 12.6109 15.9564 13.3023 15.9564 14.1551V18.0156C15.9564 18.2998 16.1869 18.5303 16.4711 18.5303H18.0153Z",
    fill: "#FFF0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.c68036b7bc71cf166a22c4dc88dcb5c9.svg";
export { ForwardRef as ReactComponent };